import init from '../../helpers/init';
import {showAlert} from '../main';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  const agreementModal = $('.js-consent-modal');
  const agreeButton = agreementModal.find('button');
  let confirmPdn: JQuery<any>;

  // выставляем статус с фронта
  $(document).on('click', '.js-ad-change-status', function(event){
    event.preventDefault();

    let url = $(this).attr('href');
    if(url){
      $.ajax(
        {
          method: 'GET',
          url: url,
          dataType: 'text'
        }
      ).done(function(data){
        location.reload();
      });
    }
  });


  agreeButton.on('click', (e: JQuery.ClickEvent) => {
    const isAgree = $(e.currentTarget).data('agree');
    if(confirmPdn){
      confirmPdn.data('agree', isAgree);
      confirmPdn.trigger('click');
    }
  });

  //отклик на объявление
  $(document).on('click', '.js-respond-ad-link', function(e){
    e.preventDefault();

    const btn = $(this);
    const contactId = $(e.currentTarget).data('id');
    const isAgree = $(e.currentTarget).data('agree');
    const ads = $(e.currentTarget).data('ads');
    const url = $(e.currentTarget).attr('href');
    const exhibitionXml = $(e.currentTarget).data('exhibition');

    if (isAgree === false) {
      agreementModal.modal('show');
      confirmPdn = $(e.currentTarget);
      return;
    }

    const data = {
      adId: ads,
      userId: contactId,
      mess: BX.message('LANGUAGE_ID') === 'en' ? 'Hello. Interested in your <a href="' + url + '">ad</a>' : 'Здравствуйте. Заинтересовало Ваше <a href="' + url + '">объявление</a>',
      exhibitionXml: exhibitionXml
    };

    BX.ajax.runComponentAction('pwd:exhibition.board', 'sendResponse', {
      data,
      mode: 'ajax'
    }).then((result: any) => {
      if (parseInt(result.result) != 0) {
        btn.html(BX.message('LANGUAGE_ID') === 'en' ? 'You have already responded' : 'Вы уже откликлнулись')
        location.href = url;
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });

  });
});
